import React from 'react';

function CodeTroopers() {
    return <><h1>CodeTroopers</h1> on vous a envoyé le dockerfile zippé</>;
}

export default CodeTroopers;